import React from 'react';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { MobileAwareOverlay } from '../../../components/MobileAwareOverlay';

export const EmailLearnMoreModal = ({ handleClose }) => {
  return (
    <MobileAwareOverlay onClose={handleClose} modalClass="preferences-modal">
      <Row>
        <Col>
          <h2>How do I update my email preferences</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            {`To make changes to your preferences,
            click on the individual preference options and press "Save Changes."`}
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <h2>How do I unsubscribe from emails?</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            To unsubscribe from future promotional emails from The Home Depot, unselect the email options.
            Please note, that on occasion you may receive transactional communications from The Home Depot.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <h2>Additional Promotional Email Details</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Please note that your consent to participate in the programs listed will be treated separately
            from your consent to participate in any of our other programs.
          </p>
        </Col>
      </Row>
    </MobileAwareOverlay>
  );
};

EmailLearnMoreModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
